<template>
    <div v-if="value">
        <input-text
            label="Titel"
            placeholder="Artikel om .."
            :required="required"
            v-model:content="value.title"
        />

        <input-editor
            label="Innehåll"
            :required="required"
            v-model:content="value.body"
        />
    </div>
    <mf-spinner-medium v-else class="w-16 h-8"></mf-spinner-medium>
</template>
<script>
import { v4 as uuidv4 } from 'uuid';

export default {
    props: {
        required: Boolean,
        modelValue: {},
    },
    emits: [
        'update:modelValue'
    ],
    data() {
        return {
            value: null
        };
    },
    async mounted() {
        this.captureModelValue();
    },
    watch: {
        modelValue() {
            if (JSON.stringify(this.value) === JSON.stringify(this.modelValue)) { return; }
            this.captureModelValue();
        },
        value: {
            handler() {
                this.$emit('update:modelValue', JSON.parse(JSON.stringify(this.value)));
            },
            deep: true
        }
    },
    methods: {
        captureModelValue() {
            const value = this.modelValue ? JSON.parse(JSON.stringify(this.modelValue)) : {};
            if (!value.id) { value.id = null; }
            if (!value.title) { value.title = null; }
            if (!value.body) { value.body = null; }
            this.value = value;
        }
    },
}
</script>
